/* eslint-disable @typescript-eslint/no-explicit-any */
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import { useEffect, useRef, useState } from "react";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Autocomplete, Grid } from "@mui/material";
import { CostModel, InvoiceLine, TaxRateModel } from "../../Utils/Models";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";
type ItemAddProp = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  manualCost: CostModel;
  setManualCost: React.Dispatch<React.SetStateAction<CostModel>>;
};
export default function ItemAdd(prop: ItemAddProp) {
  const { open, setOpen, manualCost, setManualCost } = prop;
  const ref: any = useRef();
  const [vatList, setVatList] = useState<Array<TaxRateModel>>([]);
  const [invoiceLine, setInvoiceLine] = useState(new InvoiceLine());
  const [pressOnSubmit, setPressOnSubmit] = useState(false);

  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      // reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  useEffect(() => {
    function getVatList() {
      getData(`${urlEnum.taxRates}`).then((response) => {
        if (response) {
          setVatList(response.data.result);
        }
      });
    }
    getVatList();
  }, []);

  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }

  return (
    <ValidatorForm
      ref={ref}
      onSubmit={() => {
        setManualCost({
          ...manualCost,
          items: [...manualCost.items, invoiceLine],
        });
        setOpen(false);
      }}
    >
      <AddOrUpdateModel
        open={open}
        title={Vocabulary.additem}
        onClose={() => {
          setOpen(false);
        }}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
      >
        <>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextValidator
                size="small"
                id="name"
                name="name"
                label={Vocabulary.name}
                fullWidth
                variant="outlined"
                value={invoiceLine.name}
                onChange={(event: any) => {
                  setInvoiceLine({
                    ...invoiceLine,
                    name: event.target.value,
                  });
                }}
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextValidator
                size="small"
                id="quantity"
                name="quantity"
                label={Vocabulary.quantity}
                fullWidth
                variant="outlined"
                value={invoiceLine.quantity}
                onChange={(event: any) => {
                  setInvoiceLine({
                    ...invoiceLine,
                    quantity: event.target.value,
                  });
                }}
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextValidator
                size="small"
                id="pricePerQuantity"
                name="pricePerQuantity"
                label={Vocabulary.pricePerQuantity}
                fullWidth
                type="number"
                variant="outlined"
                value={invoiceLine.totalWithoutVAT / invoiceLine.quantity}
                onChange={(event: any) => {
                  setInvoiceLine({
                    ...invoiceLine,
                    totalWithoutVAT: event.target.value * invoiceLine.quantity,
                  });
                }}
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Autocomplete
                size="small"
                id="type"
                freeSolo={true}
                options={vatList}
                getOptionLabel={(option: any) => option.name}
                isOptionEqualToValue={(option: any, value: any) =>
                  +option.value === +value.value
                }
                value={
                  invoiceLine.VATvalue
                    ? invoiceLine.VATvalue
                    : vatList.find((vat) => vat.defaultValue === true)
                }
                onChange={(event: any, value: any) => {
                  setInvoiceLine({
                    ...invoiceLine,
                    VATvalue: +value.value,
                  });
                }}
                renderInput={(params: any) => (
                  <TextValidator
                    {...params}
                    fullWidth
                    label={Vocabulary.vat}
                    variant="outlined"
                    value={""}
                  />
                )}
              />
            </Grid>
          </Grid>
        </>
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
